import { takeLatest, select, call, put } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
// import { OVERLAY_SPINNER, OVERLAY_TEXT } from "../../constants/overlayTypes";
import { PUSH_CREATE_ATTACHED_ITEM, PUSH_CREATE_DATA, PUSH_CREATE_FORM, PUSH_DATA, PUSH_DEFAULT } from "../../constants/state";
import getData from "../../functions/getData";
import { putSuccess, putError } from '../helpers'
import authUser from "../../apis/wpApi/authUser";
import { createPushCall } from "../../apis/wpApi/apiCalls";
import { OVERLAY_SPINNER } from "../../constants/overlayTypes";
import getBackgroundImage from "../../components/PageNewsletterTemplate/functions/getBackgroundImage";

function* overlaySetOverlayType(overlayType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: {overlayType: overlayType}})
}

function* overlaySetRequestType(requestType) {
    yield put({type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: requestType }})
}

const getPushCreateData = state => ({
    form: getData(state, PUSH_CREATE_FORM),
    attachedItem: getData(state, PUSH_CREATE_ATTACHED_ITEM),
})

function* createPush(action) {
    try {


         yield call(overlaySetRequestType, actionTypes.PUSH_CREATE_REQUEST)
         yield call(overlaySetOverlayType, OVERLAY_SPINNER)

        const apiKey = yield call(authUser.getToken)
        const {form, attachedItem} = yield select(getPushCreateData)
        const itemData = toDto(form, attachedItem)
    
        if(!itemData) {
            throw new Error('No push data') 
        }

        const response = yield call(createPushCall, apiKey,  _.defaults(itemData, PUSH_DEFAULT))

        if(!response || !response.status || 200 !== response.status || !response.data) {
            throw new Error('Could not create push notification')
        } else {
            yield putSuccess(actionTypes.PUSH_CREATE_REQUEST_SUCCESS, {push: response.data})
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.PUSH_CREATE_REQUEST_ERROR, e.message)
    }
}

function toDto(form, attachedItem){

    let dtoData = {
        ...form,
    }
    
    dtoData["cinemas"] = dtoData["cinemasFilter"] 

    switch(attachedItem?.itemType){
        case "movie":{
            dtoData["imageUrl"] = getBackgroundImage(attachedItem?.item)?.imgUrl
            dtoData["iconUrl"] = attachedItem?.item?.images?.poster?.url
            dtoData["moviePk"] = attachedItem?.item?.id
            break
        }
    }
    
    return dtoData
}

function* watchPushCreateRequest() {
    yield takeLatest(actionTypes.PUSH_CREATE_REQUEST, createPush);
}

export default watchPushCreateRequest
